import React from 'react'
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivelLoc = props => {
  return (
    <option>{props.elemento.descrLocalizac}</option>
  )
};

const ListaLoc = ({styles, handleLista, list}) => {
  const NivelDetalleLoc = list.map((elemento, _id) => <DetalleNivelLoc styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrLocalizac" id="miLista2" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleLoc}
      </select>
    </div>
  )
};

const DetalleNivelEmp = props => {
  return (
    <option>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, handleLista, list}) => {
  const NivelDetalleEmp = list.map((elemento, _id) => <DetalleNivelEmp styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista1" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleEmp}
      </select>
    </div>
  )
};

class AddPr2 extends React.Component{
  state = {fechaAsig: "", fechaInicio: "", fechaFinal: ""}

  handleChange = (ev) => {
    if(ev.target.name === "fechaAsig"){
      let fechaAsig = this.state.fechaAsig
      fechaAsig = ev.target.value 
      this.setState({fechaAsig});
    }
    if(ev.target.name === "fechaInicio"){
      let fechaInicio = this.state.fechaInicio
      fechaInicio = ev.target.value 
      this.setState({fechaInicio});
    }
    if(ev.target.name === "fechaFinal"){
      let fechaFinal = this.state.fechaFinal
      fechaFinal = ev.target.value 
      this.setState({fechaFinal});
    }
  }

  render(){
    const {fechaAsig, fechaInicio, fechaFinal} = this.state;
    let argsAdd = {...this.props.args}
    argsAdd.fechaAsig = fechaAsig
    argsAdd.fechaInicio = fechaInicio
    argsAdd.fechaFinal = fechaFinal
    
    return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large user plus yellow icon"></i>
        Proyecto nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, argsAdd)}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={this.props.styles.boxGrid}>
                <Form.Field>
                  <label style={this.props.styles.label}>Contrato</label>
                  <input style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.props.handleChange} placeholder='Contrato' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'contrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Empresa</label>
                  <ListaEmp list={this.props.list1} styles={this.props.styles} handleLista={this.props.handleLista1} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Ciudad</label>
                  <ListaLoc list={this.props.list2} styles={this.props.styles} handleLista={this.props.handleLista2} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Obra</label>
                  <input style={this.props.styles.input} autoComplete="off" name="obra" id="obra" onChange={this.props.handleChange} placeholder='Obra' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'obra'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" style={this.props.styles.boxGrid}>
                <Form.Field>
                  <label style={this.props.styles.label}>Fecha de asignación</label>
                  <input style={this.props.styles.input} type='date' name="fechaAsig" id="fechaAsig" value={fechaAsig} onChange={this.handleChange}/>
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Fecha de inicio</label>
                  <input style={this.props.styles.input} type='date' name="fechaInicio" id="fechaInicio" value={fechaInicio} onChange={this.handleChange}/>
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Fecha de finalización</label>
                  <input style={this.props.styles.input} type='date' name="fechaFinal" id="fechaFinal" value={fechaFinal} onChange={this.handleChange}/>
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>$ Valor</label>
                  <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTotal" id="valorTotal" placeholder='Valor' onChange={this.props.handleChange}/>
                </Form.Field>
              </div>
            </div>
          </div>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'apellidoCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
            </div>
          </div>
          <hr></hr>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">

                <Button style={this.props.styles.confirmar} type='submit' fluid>
                    AGREGAR
                </Button>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}
}

export default AddPr2
